<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  mapping: Record<string, string>
  title?: string
  variant?: 'card' | 'embedded' 
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Preview dos Dados',
  variant: 'card'
})

const fieldsCount = computed(() => props.mapping ? Object.keys(props.mapping).length : 0)

const containerClasses = computed(() => {
  if (props.variant === 'embedded') {
    return 'bg-transparent' 
  }
  return 'bg-white shadow dark:bg-gray-900 rounded-sm' 
})
</script>

<template>
  <div :class="containerClasses">
    
    <div v-if="variant === 'card'" class="mb-0 flex items-center justify-between px-4 py-4 border-b border-gray-200 dark:border-gray-700">
       <div class="text-sm font-bold text-gray-700 dark:text-gray-200">
         {{ title }}
       </div>
       <div class="text-sm text-gray-500">
         Total de campos: {{ fieldsCount }}
       </div>
    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full table-auto text-left text-sm text-gray-700 dark:text-gray-200">
        
        <thead>
          <tr class="bg-gray-100 text-xs font-semibold uppercase text-gray-700 dark:bg-gray-800 dark:text-gray-200">
            <th scope="col" class="whitespace-nowrap px-4 py-3">
              Campo no Sistema
            </th>
            <th scope="col" class="whitespace-nowrap px-4 py-3">
              Dado Recebido (Sensor)
            </th>
          </tr>
        </thead>

        <tbody>
          <tr 
            v-for="(value, key, index) in mapping" 
            :key="key" 
            :class="[
              index % 2 === 0 ? 'bg-white dark:bg-gray-800' : 'dark:bg-gray-850 bg-gray-50', 
              'border-b border-gray-200 dark:border-gray-700'
            ]"
          >
            <td class="whitespace-nowrap px-4 py-3 font-medium">
              {{ key }}
            </td>
            <td class="whitespace-nowrap px-4 py-3 font-mono text-blue-600 dark:text-blue-400">
              {{ value }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>